import { render, staticRenderFns } from "./ReInputSyntaxHighlight.vue?vue&type=template&id=3389692f&scoped=true"
import script from "./ReInputSyntaxHighlight.vue?vue&type=script&lang=js"
export * from "./ReInputSyntaxHighlight.vue?vue&type=script&lang=js"
import style0 from "./ReInputSyntaxHighlight.vue?vue&type=style&index=0&id=3389692f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389692f",
  null
  
)

export default component.exports